<template>
  <div :class="$style.style">
    <div class="header-view"><!--
      <div class="img-edit">
        <div class="edit-div">
          <img id="image" class="header-view-image" :src="imgSrc?imgSrc:'https://res.wx.qq.com/wxopenres/htmledition/images/spacer32f740.gif'"/>
        </div>
      </div>-->
      <div class="img-view">
        <div class="square">
          <div class="headerview520">
            <img class="imagev" :src="imgSrc?imgSrc:'https://res.wx.qq.com/wxopenres/htmledition/images/spacer32f740.gif'"/>
          </div>
        </div>
        <div class="circle">
          <div class="headerview520">
            <img class="imagev" :src="imgSrc?imgSrc:'https://res.wx.qq.com/wxopenres/htmledition/images/spacer32f740.gif'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /*!
  * 裁剪控件：
  * https://github.com/fengyuanchen/cropperjs
  *
  * 参考：https://blog.csdn.net/leileibrother/article/details/78655371
  *
  * 参数：长宽比：ratio '1' 16/9 样式 show1 213.33*120 ; '2' 1 样式 show2 120*120
  * 
  */
import Cropper from 'cropperjs';
import axios from 'axios';
import { Message } from 'element-ui';
export default {
  props: {
    imgObj: {type: Object, default: {imgSrc: '', x1: 0, y1: 0, x2: 1, y2: 1}},
    imgUrl: { type: String, default: '' },
    x1: { type: Number, default: 0},
    y1: { type: Number, default: 0},
    x2: { type: Number, default: 1},
    y2: { type: Number, default: 1}
  },
  data () {
    return {
      imgSrc: '',
      result: this.value
    }
  },
  mounted () {
    if (this.imgObj) {

    var self = this;
    // 图片地址
    self.imgSrc = this.imgObj.imgSrc;
    var img_url = this.imgObj.imgSrc;
    // 创建对象
    var img = new Image()
    // 改变图片的src
    img.src = img_url
    let aw = 100;
    let ah = 100;
    // 打印
    // 加载完成执行
    // 判断是否有缓存
    if(img.complete){
        // 打印
        // alert('from:complete : width:'+img.width+',height:'+img.height);
        aw = img.width;
        ah = img.height;
        var previews = document.querySelectorAll('.headerview520');

        let vw = (self.x2-self.x1)*aw;
        var previewAspectRatio = vw / 100;

        self.each(previews, function (elem) {
          var previewImage = elem.getElementsByTagName('img').item(0);
          if (previewImage) {
            previewImage.style.width = aw / previewAspectRatio + 'px';
            previewImage.style.height = ah / previewAspectRatio + 'px';
            previewImage.style.marginLeft = -self.x1*aw / previewAspectRatio + 'px';
            previewImage.style.marginTop = -self.y1*ah / previewAspectRatio + 'px';
          }
        });
    }else{
        // 加载完成执行
        img.onload = function(){
            // 打印
            // alert('from:onload : width:'+img.width+',height:'+img.height);
            aw = img.width;
            ah = img.height;
            var previews = document.querySelectorAll('.headerview520');

            let vw = (self.x2-self.x1)*aw;
            var previewAspectRatio = vw / 100;

            self.each(previews, function (elem) {
              var previewImage = elem.getElementsByTagName('img').item(0);
              if (previewImage) {
                previewImage.style.width = aw / previewAspectRatio + 'px';
                previewImage.style.height = ah / previewAspectRatio + 'px';
                previewImage.style.marginLeft = -self.x1*aw / previewAspectRatio + 'px';
                previewImage.style.marginTop = -self.y1*ah / previewAspectRatio + 'px';
              }
            });
        };
    }
    // this.getImg(self.imgSrc);
    // debugger;
    // var image = document.getElementById('image');
    // alert(this.getWH(image, 'width'));
    // var image = document.getElementById('image');
  }
  },
  watch: {
    imgObj: function(val) {
    if(val&&val.imgSrc) {
      var self = this;
      self.imgSrc = val.imgSrc;
      // 图片地址
      var img_url = val.imgSrc;
      // 创建对象
      var img = new Image()
      // 改变图片的src
      img.src = img_url
      let aw = 100;
      let ah = 100;
      // 判断是否有缓存
      if(img.complete){
          aw = img.width;
          ah = img.height;

          var previews = document.querySelectorAll('.headerview520');

          let vw = (val.x2-val.x1)*aw;
          console.log(aw);
          var previewAspectRatio = vw / 100;

          self.each(previews, function (elem) {
            var previewImage = elem.getElementsByTagName('img').item(0);
            if (previewImage) {
              previewImage.style.width = aw / previewAspectRatio + 'px';
              previewImage.style.height = ah / previewAspectRatio + 'px';
              previewImage.style.marginLeft = -val.x1*aw / previewAspectRatio + 'px';
              previewImage.style.marginTop = -val.y1*ah / previewAspectRatio + 'px';
            }
          });
      }else{
          // 加载完成执行
          img.onload = function(){
              aw = img.width;
              ah = img.height;

            var previews = document.querySelectorAll('.headerview520');

            let vw = (val.x2-val.x1)*aw;
            console.log(aw);
            var previewAspectRatio = vw / 100;

            self.each(previews, function (elem) {
              var previewImage = elem.getElementsByTagName('img').item(0);
              if (previewImage) {
                previewImage.style.width = aw / previewAspectRatio + 'px';
                previewImage.style.height = ah / previewAspectRatio + 'px';
                previewImage.style.marginLeft = -val.x1*aw / previewAspectRatio + 'px';
                previewImage.style.marginTop = -val.y1*ah / previewAspectRatio + 'px';
              }
            });
          };
      }
    }
    // this.getImg(val);
    // debugger;
    //   var img = document.getElementsByTagName('img')[0];

    //   var previews = document.querySelectorAll('.header-view-image');
    // alert(this.getWH(previews[0], 'width'));
    //   var image = document.getElementById('image');
    //   debugger;
      // var image = document.getElementById('image');
      // var previews = document.querySelectorAll('.preview');

      // let vw = (this.x2-this.x1);
      // let aw = image.style.width;
      // debugger;
    }
  },
  methods: {
    async getImg(src) {
      let img = await this.util(src)
      console.log('width', img.width)
      console.log('height', img.height)
    },

    util(data) {
      return new Promise((resolve, reject) => {
        // let reader = new FileReader()
        // reader.onload = function (e) {
          // let data = e.target.result
          let img = new Image()
          img.src = data
          img.onload = function () {
            resovle({
              width: img.width,
              height: img.height
            })
            console.log('width', img.width)
            console.log('height', img.height)
          }
        // }
        // reader.readAsDataURL(file)
      })
    },

    getStyle(el,name) {
        if(window.getComputedStyle) {
            return window.getComputedStyle(el, null)[name];
        }else{
            return el.currentStyle[name];
        }
    },
    getWH(el, name) {
        var val = name === "width" ? el.offsetWidth : el.offsetHeight,
            which = name === "width" ? ['Left', 'Right'] : ['Top', 'Bottom'];
         
        // display is none
        if(val === 0) {
            return 0;
        }
 
        for(var i = 0, a; a = which[i++];) {
            val -= parseFloat( this.getStyle(el, "border" + a + "Width") ) || 0;
            val -= parseFloat( this.getStyle(el, "padding" + a) ) || 0;
        }
     
        return val + 'px';
    },
    each(arr, callback) {
      var length = arr.length;
      var i;

      for (i = 0; i < length; i++) {
        callback.call(arr, arr[i], i, arr);
      }

      return arr;
    },
  }
}
</script>
<style lang="less" module>
:local(.style) {
  margin: 0;  
  padding: 0;
  .header-view {
    // height: 150px; 
    text-align: left;
    .btn-upload {
      display: inline-block;
      vertical-align: top;
    }
    .img-edit {
      display: inline-block;
      .edit-div {
        width: 150px;
        height: 150px;
        background: #F6F8F9;
      }
    }
    .img-view {
      display: inline-block;
      height: 120px;
      padding: 10px 20px;
      background: #F6F8F9;
      vertical-align: top;
      .text {
        line-height: 22px;
      }
      .square {
        height: 100px;
        width: 100px;
        display: inline-block;
        margin-right: 20px;
        overflow: hidden;
        .headerview520 {
          height: 100px;
          overflow: hidden;
          border-radius: 4px;
          background:#fff;
        }
      }
      .circle {
        height: 100px;
        width: 100px;
        display: inline-block;
        overflow: hidden;
        .headerview520 {
          overflow: hidden;
          height: 100px;
          border-radius: 50%;
          background:#fff;
        }
      }
    }
  }
  .header-img .image {  
    max-width: 100%;  
  }

}
</style>